<template>
	<div class="">
        <template v-if="create_payroll_batch === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Generate Payroll </h1>
                <button class="btn btn-primary float-right" @click="processReview" :disabled="processDisabled == true"> Submit </button>
                <button class="btn btn-primary float-right mr-1" @click="cancelAutoGeneratePayroll"> Cancel </button>
                <div class="head-date float-right mr-2"> {{autoPayroll_date}} <i class="far fa-clock"></i> </div>
            </div>
            <hr class="border" />
            <div class="row normal-ib-space align-items-center mb-3">
                <div class="col-md-3"> <input id="customSearch" type="text" class="form-control search" placeholder="Search employee by name or Wallet Number" title="Search employee by name or Wallet Number" name="" /> </div>
                <div class="col-md-9">
                    <ul class="page-status text-right border-bottom-0 p-0">
                        <li class="page-status-list done">
                            <router-link :to="/autoPaymentUsers/+$route.params.id">
                                <span class="status-highlighter">1</span>Employees
                            </router-link>
                        </li>
                        <li class="page-status-list done">
                            <router-link :to="/autoPaymentTimeOff/+$route.params.id">
                                <span class="status-highlighter">2</span>Time Off
                            </router-link>
                        </li>
                        <li class="page-status-list done">
                            <router-link :to="/autoPaymentEarnings/+$route.params.id">
                                <span class="status-highlighter">3</span>Earnings
                            </router-link>
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">4</span>
                            Review and Submit
                        </li>
                    </ul>
                </div>
            </div>
            <div class="autogenerate-content">
                <div class="total-autogenerate-payroll text-center mb-3">
                    <p> Total payment for {{ autoPayroll_date }} </p>
                    <p class="payroll-amount" v-if="autoPayroll.net_amount != null"> {{formatAmount(autoPayroll.net_amount)}} </p>
                </div>
                <table id="dt-autogenerate-review" class="table" style="width:100%">
                    <thead>
                        <tr>
                            <th>Employees</th>
                            <th>Gross Pay</th>
                            <th>Additional Earnings</th>
                            <th>Reimbursements</th>
                            <th>Deductions</th>
                            <th>Time Off</th>
                            <th class="text-center">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="reviewUser in reviewUsers" v-bind:key="reviewUser.id" >
                            <td class="">
                                <div class="image-title">
                                    <div class="image-holder entity-detail-tooltip" data-toggle="tooltip">
                                        <img v-if="reviewUser.user.avatar != null" :src="'/avatar/'+reviewUser.user.avatar" alt="" />
                                        <img v-else src="/images/table-dummy-image.jpg" alt="" />
                                    </div>
                                    <div class="ag-employee-part">
                                        <span class="name"> {{reviewUser.user.name}} </span>
                                        <span class="emp-status"> {{reviewUser.user.status}} </span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{reviewUser.user.net_salary}}
                            </td>
                            <td>
                                {{reviewUser.addtional_earning.overtime}} Overtime<br>
                                {{reviewUser.addtional_earning.bonus}} Bonus<br>
                                {{reviewUser.addtional_earning.commission}} Commission<br>
                                {{reviewUser.addtional_earning.otherAdditionalEarning}} Others <br>
                                {{reviewUser.addtional_earning.conveyance}} Conveyance <br>
                                {{reviewUser.addtional_earning.cola}} Cola <br>
                                {{reviewUser.addtional_earning.utility}} Utility <br>
                                {{reviewUser.addtional_earning.one_time}} One TIme
                            </td>
                            <td>
                                {{reviewUser.reimbursement.fuelreimbursement}} Fuel<br>
                                {{reviewUser.reimbursement.travelreimbursement}} Travel<br>
                                {{reviewUser.reimbursement.otherreimbursement}} Others<br>
                            </td>
                            <td>
                                {{reviewUser.deductions.incometax}} Income Tax<br>
                                {{reviewUser.deductions.eobi}} EOBI<br>
                                {{reviewUser.deductions.providentfund}} Provident fund<br>
                                {{reviewUser.deductions.otherdeduction}} Others<br>
                                {{reviewUser.deductions.advances}} Advances
                            </td>
                          <td>
                            {{ reviewUser.leaves_absents == null ?  0 : reviewUser.leaves_absents.absents  }} Absents<br>
                            {{ reviewUser.leave_absent_deduction == null ? 0 : formatAmount(reviewUser.leave_absent_deduction)  }} Absents Deduction <br>
                            {{ reviewUser.leaves_absents == null ? 0 : formatAmount(reviewUser.leaves_absents.totalAmount) }} Total Deductible
                          </td>
                            <td class="text-center">{{formatAmount(reviewUser.earning_salary)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template v-else-if="create_payroll_batch === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="create_payroll_batch === false">
            <notAllowed></notAllowed>
        </template>
	</div>
</template>

<script>
    var dtAutoGenerateReviewTable = null;
    export default {
        data() {
            return {
                create_payroll_batch:  null,
                autoPayroll: [],
                reviewUsers: [],
                autoPayroll_date: '',
                processDisabled: false,
                additional_earning: [],
                reimbursent: [],
                deduction: []
            }
        },
        methods: {
            // getAutoGenerateReviewData: function(){
            //     axios.get('/api/autoPaymentReview/'+this.$route.params.id)
            //     .then(res => {
            //         this.autoPayroll    = res.data.autoGenPayroll;
            //         this.reviewUsers    = res.data.records;
            //         var date = moment(this.autoPayroll.from_date);
            //         this.autoPayroll_date = date.format('MMMM, YYYY');
            //         this.$Progress.finish();
            //     })
            //     .then(res => {
            //         this.callDataTable();
            //     })
            //     .catch(err => {
            //         console.log(err);
            //         this.showAlertBox('error','Error to load data');
            //     });
            // },
          async getAutoGenerateReviewData() {
            try {
              const response = await axios.get(`/api/autoPaymentReview/${this.$route.params.id}`);

              this.autoPayroll = response.data.autoGenPayroll;
              this.reviewUsers = response.data.records;

              const date = moment(this.autoPayroll.from_date);
              this.autoPayroll_date = date.format('MMMM, YYYY');

              this.$Progress.finish();

              this.callDataTable();
            } catch (error) {
              console.error(error);
              this.showAlertBox('error', 'Error loading data');
            }
          },
            callDataTable(){
                    dtAutoGenerateReviewTable = $('#dt-autogenerate-review').DataTable({
                        "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                        "searching":true,
                        columnDefs: [ {
                            orderable: false,
                        }],
                        order: [[ 0, "desc" ]],
                    });
                    $('#customSearch').on( 'keyup', function () {
                        completeTable.search( this.value ).draw();
                    });

                    var vendorDetailTooltip = '<div class="autogenerate-detail-tooltip">' +
                                            '<h2> Jawad Amjad </h2>'+
                                            '<p class="custom-tooltip-content">' +
                                                '<span class="tooltip-col tooltip-title"> Account Type </span>' +
                                                '<span class="tooltip-col">  SIMSIM </span>' +
                                            '</p>' +
                                            '<p class="custom-tooltip-content">' +
                                                '<span class="tooltip-col tooltip-title"> SimSim/Account No. </span>' +
                                                '<span class="tooltip-col"> 923784613136 </span>' +
                                            '</p>' +
                                            '<p class="custom-tooltip-content">' +
                                                '<span class="tooltip-col tooltip-title"> Employment Status </span>' +
                                                '<span class="tooltip-col"> PERMANENT </span>' +
                                            '</p>' +
                                            '<p class="custom-tooltip-content">' +
                                                '<span class="tooltip-col tooltip-title"> Department </span>' +
                                                '<span class="tooltip-col"> Development </span>' +
                                            '</p>' +
                                        '</div>';
                $(".entity-detail-tooltip").tooltip({
                    title: vendorDetailTooltip,
                    html: true,
                    placement: 'top',
                    offset: '80',
                    template: '<div class="tooltip custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'

                });
            },
            cancelAutoGeneratePayroll(){
                swal.fire({
                    title: 'Are you sure?',
                    // text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    var id = this.autoPayroll.id;
                    if (result.value) {
                        axios.post('/api/cancelAutoGeneratePayroll', {id})
                            .then(res => {
                                if(res.data.status == '200'){
                                    this.showToastBox('success',res.data.msg);
                                    this.$router.push('/employeePayments');
                                }else{
                                    this.showToastBox('error',res.data.msg);
                                }
                            })
                            .catch(err => {
                                this.showAlertBox('error','System Not Responding Please Try Again');
                            });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        this.showAlertBox('error','Cancelled','Your decision has been cancelled');
                    }
                });
            },
            processReview(){
                this.$Progress.start();
                this.processDisabled = true;
                var formData = {
                   id      : this.autoPayroll.id
                };
                axios.post('/api/processAutoPayrollReview', formData)
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.msg);
                            this.$router.push('/viewEmployeePaymentBatchSheet/'+res.data.sheet_id);
                        }else{
                            this.$Progress.fail();
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            }
        },
        created() {

        },
        mounted() {
            this.$Progress.start();
			this.can('create_payroll_batch').then(result => {
                this.create_payroll_batch = result.create_payroll_batch;
            }).then(result => {
                if(this.create_payroll_batch == true){
					this.getAutoGenerateReviewData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
